import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CamMap = _resolveComponent("CamMap")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CamMap),
    _hoisted_1
  ], 64))
}